import { NBuilderProductsSetup } from './products-setup/builder-products-setup.config';
export namespace NBuilderConfig {
    export const updateStorageEvent = 'builder-update-storage';
    export interface ISetupElementData {
        name: string;
        image: string;
        preselect: boolean;
        mobileImage?: string;
        imageConfiguration?: string;
        alternativeImageConfiguration?: string;
    }
    export interface ISimpleStep {
        title: string;
        tabs?: {
            id: number;
            title: string;
            options: ISetupElementData[];
        }[];
    }
    export interface IStorageData extends NBuilderProductsSetup.IStorageData {}
    export interface IPageData extends NBuilderProductsSetup.IProductsSetupData {}
}
